import type { OptionItem } from "~/types";

// 新卒・中途　職種
export const jobList: OptionItem[] = [
  { id: 1, name: "プランナー（総合職）" },
  { id: 2, name: "事務職（一般職）" },
];

// 職人　職種
export const contractorList: OptionItem[] = [
  { id: 1, name: "外構" },
  { id: 2, name: "エクステリア" },
  { id: 3, name: "塗装" },
  { id: 4, name: "水まわり" },
];

// 新卒・中途　エリア
export const areaList: OptionItem[] = [
  { id: 1, name: "大阪府" },
  { id: 2, name: "奈良県" },
  { id: 3, name: "兵庫県" },
  { id: 4, name: "京都府" },
  { id: 5, name: "滋賀県" },
  { id: 6, name: "和歌山県" },
  { id: 7, name: "神奈川県" },
  { id: 8, name: "埼玉県" },
  { id: 9, name: "三重県" },
  { id: 10, name: "愛知県（名古屋）" },
  { id: 11, name: "福岡県" },
  { id: 12, name: "どこでも可" },
];

// 新卒・中途　性別
export const genderList: OptionItem[] = [
  { id: 1, name: "男" },
  { id: 2, name: "女" },
];
